import { render, staticRenderFns } from "./Salons.vue?vue&type=template&id=9380ca88&scoped=true"
import script from "./Salons.vue?vue&type=script&lang=js"
export * from "./Salons.vue?vue&type=script&lang=js"
import style0 from "./Salons.vue?vue&type=style&index=0&id=9380ca88&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9380ca88",
  null
  
)

export default component.exports